import React, { useMemo, useState, useCallback, useEffect } from "react";
import { StatsContainer, DataTable, Button, InputField } from "@/components";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import ColumnHelper from "@/utils/ColumnHelper";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { RightWrapper } from "../../../components";
import { LuPackageSearch } from "react-icons/lu";
import CodRemittanceDue from "./CodRemittanceDue";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { fetchCustomerCODDues, selectCustomerById } from "../../../app/Slices";
import { useAlert } from "@/";
import { BsArrowLeftShort } from "react-icons/bs";
const CustomerCodRemittance = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams() || {};
  const [sheetOpen, setSheetOpen] = useState(false);
  const { alert, AlertDialog } = useAlert();

  const customers = useSelector((state) => selectCustomerById(state, id)) || [];
  const fetchData = async () => {
    try {
      const response = await dispatch(
        fetchCustomerCODDues({
          userId: id,
        })
      );
      if (fetchCustomerCODDues.fulfilled.match(response)) {
        // console.log("CodDues FullFilled::::::", response);
      } else if (fetchCustomerCODDues.rejected.match(response)) {
        alert(response.payload);
        // console.log("CodDues Rejected::::::", response);
      }
    } catch (error) {
      console.error("Error fetching COD dues:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch]);

  const customerDues =
    useSelector((state) => state.customerDue.customerCODDues) || [];
  const CustomerDuesData = customerDues?.COD || [];
  console.log("CustomerDuesData>>>>>", CustomerDuesData);
  const CustomerDuesIsLoading = useSelector(
    (state) => state.customerDue.loading
  );

  const handleBackClick = useCallback(() => {
    navigate("/customer");
  }, [navigate]);

  const [amount, setAmount] = useState("");

  const formatDate = (dateString) => {
    return dateString
      ? new Date(dateString).toISOString().split("T")[0]
      : "N/A";
  };

  const handleCheck = (amt) => {
    if (!amount) {
      alert("Please enter an amount to check");
      return;
    }

    if (amount <= 0) {
      alert("Please enter a valid amount to check");
      return;
    }

    if (amount > customerDues?.totalDueAmount) {
      alert("Amount cannot exceed total due amount");
      return;
    }

    setSheetOpen(true);
  };
  const columns = useMemo(
    () => [
      ColumnHelper({
        header: "AWB",
        accessorKey: "awbNumber",
        meta: {
          tooltip: (row) => row.awbNumber || "N/A",
        },
      }),
      ColumnHelper({
        header: "Shipping ID",
        accessorKey: "shippingId",
        meta: {
          tooltip: (row) => row.shippingId || "N/A",
        },
      }),
      ColumnHelper({
        header: "Booking Date",
        accessorKey: "createdAt",
        cell: (info) => formatDate(info.row.original.createdAt),
        meta: {
          tooltip: (row) => formatDate(row.createdAt) || "N/A",
        },
      }),
      ColumnHelper({
        header: "COD Amount Due",
        accessorKey: "dueAmount",
        meta: {
          tooltip: (row) => row.dueAmount || "N/A",
        },
      }),

      ColumnHelper({
        header: "Courier",
        accessorKey: "courier",
        meta: {
          tooltip: (row) => row.courier || "N/A",
        },
      }),
      ColumnHelper({
        header: "Channel",
        accessorKey: "channel",
        meta: {
          tooltip: (row) => row.channel || "N/A",
        },
      }),
    ],
    []
  );
  const formatAmount = (num) => parseFloat(num).toFixed(2);
  const StatsCodCustomerDue = [
    {
      statusName: "Total Remittance Due to Customer  ",
      statusNumber: formatAmount(customerDues?.totalDueAmount || 0),
    },
    {
      statusName: "Total Remittance given to Customer  ",
      statusNumber: formatAmount(customerDues?.totalRemittance || 0),
    },
    {
      statusName: " Remittance Received from Courier Partner  ",
      statusNumber: formatAmount(customerDues?.totalReceiveAmount || 0),
    },
    {
      statusName: "Remittance Due from Courier Partner  ",
      statusNumber: formatAmount(customerDues?.remittanceDueFromCourier || 0),
    },
    {
      statusName: `Last Remittance ( ${
        formatDate(customerDues?.lastRemittanceDate) || "N/A"
      })`,
      statusNumber: formatAmount(customerDues?.lastRemittance || 0),
    },
    {
      statusName: "Next  Remittance   ",
      statusNumber: formatAmount((customerDues?.totalDueAmount || 0) * 0.3),
    },
    {
      statusName: "Weight Dispute  ",
      statusNumber: customerDues?.weightDispute || 0,
    },
    {
      statusName: "Wallet Balance  ",
      statusNumber: formatAmount(customerDues?.balance || 0),
    },
  ];
  return (
    <RightWrapper>
      <div className="flex flex-col gap-4 mt-2 px-2 relative pb-20 md:pb-4 ">
        <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
          <SheetContent aria-describedby="">
            <SheetHeader>
              <SheetTitle>
                <span className="text-headline5 md:text-headline4 text-secondary/90 font-nunito font-semibold flex items-center ">
                  Amount - &nbsp;{" "}
                  <FaIndianRupeeSign className="!text-secondary/90 text-lg" />
                  {amount.toLocaleString()}
                </span>
              </SheetTitle>
            </SheetHeader>
            <CodRemittanceDue
              setSheetOpen={setSheetOpen}
              data={CustomerDuesData}
              amount={amount}
              uid={id}
            />
          </SheetContent>
        </Sheet>
        <div className="flex items-center gap-2  text-headline4 lg:text-headline3 text-secondary/90 font-nunito font-semibold ">
          <BsArrowLeftShort
            onClick={handleBackClick}
            className="text-4xl lg:text-5xl text-secondary/70 hover:bg-secondary/5 rounded-xl font-nunito font-bold cursor-pointer"
          />
          <span className="flex items-center gap-0.5">
            <span className="mr-1">
              {customerDues?.user?.name || "Unknown Customer"}
            </span>
            <span className="text-[32px] font-bold font-nunito">#</span>
            <span>{customerDues?.user?.clientId || "Unknown Customer"}</span>
          </span>
        </div>
        <StatsContainer
          status={StatsCodCustomerDue}
          label="COD Remittance "
          lgCols={4}
        />
        <div className="flex justify-end items-end gap-1 w-full ">
          <div className="flex justify-end items-end gap-2 w-full md:w-1/3">
            <InputField
              label="Due Shipments with Amount"
              placeholder="Enter Amount"
              id="amount"
              type="number"
              value={amount}
              onChange={setAmount}
            />
            <Button
              size="sm"
              onClick={handleCheck}
              className="h-12"
              icon={LuPackageSearch}
            >
              Check
            </Button>
          </div>
        </div>
        <DataTable
          columns={columns}
          tittle={`All COD Due's (${CustomerDuesData.length || 0}) `}
          data={CustomerDuesData}
          isLoading={CustomerDuesIsLoading}
          showCheckbox={false}
        />
      </div>
      <AlertDialog />
    </RightWrapper>
  );
};

export default CustomerCodRemittance;
